// extracted by css-extract-rspack-plugin
export default {"root":"_2QxZdsA8rluI00MvXqutOw","small":"_3VQxtSN6y14r3oFbqZWgFq","medium":"_2B4VQGTW03CQGarKQ0rmGA"};